import { defineMessages } from "react-intl";

export const lineAlertMessages = defineMessages({
  notPublished: {
    id: "Oad+ES",
    defaultMessage: "This product is not published in this channel.",
    description: "alert message",
  },
  notAvailable: {
    id: "zO+l0L",
    defaultMessage: "This product is not available for sale in this channel.",
    description: "alert message",
  },
  notExists: {
    id: "pEMxyy",
    defaultMessage: "This product does no longer exist.",
    description: "alert message",
  },
});
